import { useInView } from "framer-motion";
import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const AnimateFade = ({ children, className, ...props }: Props) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div
      ref={ref}
      style={{
        opacity: isInView ? 1 : 0,
        transition: "all 1s ease-in 0.1s",
      }}
      {...props}
      className={className}
    >
      {children}
    </div>
  );
};
